var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"emoji-item-common",class:['emoji-'+_vm.text,_vm.isInput?'emoji-size-small':'emoji-size-large'],on:{"click":_vm.emojiClick}})}
var staticRenderFns = []

export { render, staticRenderFns }